import React from "react";
import cx from "../../utils/cx";
import s from "./index.css";
export * from "./CloseBtn";

export default ({
  open,
  children,
  onClose = v => v,
  scale = true,
  fadeUp = true
}) => (
  <div
    className={cx({
      [s.modal]: true,
      [s.open]: !!open
    })}
  >
    <div className={s.modalOverlay} onClick={onClose} />
    <div
      className={cx({
        [s.modalContent]: true,
        [s.scale]: scale,
        [s.fadeUp]: fadeUp
      })}
    >
      {children}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Modal/index.js